export default {
  close: 'Close',
  createNewTeam: 'Create new team',
  header: 'Your team has been deleted',
  info: 'Your team and all associated data are being deleted permanently. Please allow time to wipe the data from our servers.',
};
